import { Component, OnInit, NgModule, Input, Output, EventEmitter } from "@angular/core";
import { Modules, UserRole, ServiceType, OriginCustomsBroker, DemandeStatus, IDChatComponent, TypeCustomsBroker } from "../../utils/enumeration";
import { UploadInput, UploadOutput, UploadFile } from "ngx-uploader";
import { MultiUploadComponent } from "../../utils/multiUploadComponent";
import { DomSanitizer } from "@angular/platform-browser";
import { FileType } from "../../utils/enumeration";
import { EbUser } from "../../classes/user";
import { FichierJoint } from "../../classes/fichiersJoint";
import { StatiqueService } from "../../services/statique.service";
import { PricingService } from "../../services/pricing.service";
import { Statique } from "../../utils/statique";
import { ModalService } from "../../shared/modal/modal.service";
import { TranslateService } from '@ngx-translate/core';
import { UserService } from "../../services/user.service";
import { EbDemande } from "../../classes/demande";
import { EbChat } from "../../classes/chat";
import { ChatService } from "../../services/chat.service";
import { Router } from "@angular/router";
import { EbTracing } from "../../classes/tracing";
import { EbExpedition } from "../../classes/expedition";

@Component({
	selector: "app-documents",
	templateUrl: "./documents.component.html",
	styleUrls: ["./documents.component.css"]
})
export class DocumentsComponent extends MultiUploadComponent implements OnInit {
	Statique = Statique;
	Modules = Modules;
	UserRole = UserRole;

	dataUpload: any;
	fileTypeEnum = FileType;
	listEbDemandeFichierJointNum: Array<number> = new Array<number>();
	uploadEnCours: boolean = false;
	_ebDemande: EbDemande;
	_ebExpedition: EbExpedition = null;
	_userConnected: EbUser;
	_module: number;

	@Input()
	set module(_module: number) {
		this._module = _module;
		this.retrieveListDocuments();
	}
	get module(): number { return this._module }

	@Input()
	set ebDemande(ebDemande: EbDemande) {
		this._ebDemande = ebDemande;
		this.retrieveListDocuments();
	}
	get ebDemande(): EbDemande { return this._ebDemande; }

	@Input() ebTracing: EbTracing;
	@Input()
	set userConnected(_userConnected: EbUser) {
		this._userConnected = _userConnected;
		this.retrieveListDocuments();
	}
	get userConnected(): EbUser { return this._userConnected }
	@Input() hasContributionAccess?: boolean;
	@Input() documentsToShow: Array<number> = new Array<number>();
	@Input()
	set ebExpedition(ebExpedition: EbExpedition) {
		this._ebExpedition = ebExpedition;
		this.retrieveListDocuments();
	}

	get ebExpedition(): EbExpedition { return this._ebExpedition }


	@Input() filesReturnToParent?: Array<Array<FichierJoint>> = new Array<Array<FichierJoint>>();
	@Output() onValidate = new EventEmitter<any>();
	@Output() updateChatEmitter = new EventEmitter<EbChat>();

	dataSource: string;
	dataInsertion: string;

	ebChat: EbChat;

	ConstantsTranslate: Object;

	constructor(
		protected sanitizer: DomSanitizer,
		protected statiqueService: StatiqueService,
		private pricingService: PricingService,
		protected modalService: ModalService,
		protected translate: TranslateService,
		protected chatService: ChatService,
		private router: Router
	) {
		super(sanitizer);
		this.dataUpload = { typeFile: String(this.UploadDirectory.COTATION_DOCS) };
		this.componentObject = this;

	}

	ngOnInit() {

		if (typeof this.hasContributionAccess == "undefined")
			this.hasContributionAccess = false;
		if (typeof this.documentsToShow == "undefined")
			this.documentsToShow = null;

		this.ConstantsTranslate = {
			CONFIRMATION: '',
			DELETE_FILE_CONFIRMATION: '',

			INVOICE: '',
			LISTE_COLISAGE: '',
			DOUANE: '',
			TRANSPORT_DOCUMENT: '',
			POD: '',
			OTHER: '',
		};
		Object.keys(this.ConstantsTranslate).forEach(key => {
			this.translate.get("PRICING_BOOKING." + key).subscribe(res => this.ConstantsTranslate[key] = res)
		});

		if (this.ebDemande.ebDemandeNum != null || (this.ebExpedition != null && this.ebExpedition.ebExpeditionNum != null)) this.retrieveListDocuments();

		this.module = Statique.getModuleNumFromUrl(this.router.url);
	}

	onUploadFiles(output: UploadOutput, filetype): void {
		this.fileType = filetype;
		this.componentObject.dataUpload.ebDemandeNum = this.ebDemande.ebDemandeNum || 0;
		this.componentObject.dataUpload.ebExpeditionNum = (this.ebExpedition != null && this.ebExpedition.ebExpeditionNum != null) ? this.ebExpedition.ebExpeditionNum : "";
		this.componentObject.dataUpload.ebUserNum = this.userConnected.ebUserNum;
		this.componentObject.dataUpload.ebEtablissementNum = this.userConnected.ebEtablissement.ebEtablissementNum;
		this.onUploadOutput(output);
	}

	historizeChat(category: number, action: string) {
		let ebChat = new EbChat();
		ebChat.userName = this.userConnected.nom + " " + this.userConnected.prenom;
		ebChat.xEbUser = this.userConnected.ebUserNum;
		ebChat.module = this.module;
		ebChat.idFiche = this.ebDemande.ebDemandeNum;
		ebChat.isHistory = true;
		if (this.module == Modules.PRICING)
			ebChat.idChatComponent = IDChatComponent.PRICING;
		else if (this.module == Modules.TRANSPORT_MANAGEMENT)
			ebChat.idChatComponent = IDChatComponent.TRANSPORT_MANAGEMENT;
		else if (this.module == Modules.TRACK) {
			ebChat.idFiche = this.ebTracing.ebTtTracingNum;
			ebChat.idChatComponent = IDChatComponent.TRACK;
		}
		/* 	else if(this.module== Modules.REPO_DEVISE){
				ebChat.idFiche = 0;
				ebChat.idChatComponent = IDChatComponent.REPO_DEVISE;
			} */
		else return;

		let fileType: string = "";
		if (category == FileType.LISTE_COLISAGE)
			fileType = this.ConstantsTranslate["LISTE_COLISAGE"];
		else if (category == FileType.DOUANE)
			fileType = this.ConstantsTranslate["DOUANE"];
		else if (category == FileType.INVOICE)
			fileType = this.ConstantsTranslate["INVOICE"];
		else if (category == FileType.OTHER)
			fileType = this.ConstantsTranslate["OTHER"];
		else if (category == FileType.POD)
			fileType = this.ConstantsTranslate["POD"];
		else if (category == FileType.TRANSPORT_DOCUMENT)
			fileType = this.ConstantsTranslate["TRANSPORT_DOCUMENT"];
		else fileType = "Document";

		if (this.userConnected.realUserNum) {
			ebChat.text = fileType + " " + action + " by <b> " + this.userConnected.realUserNom + " " + this.userConnected.realUserPrenom + '</b>';
			ebChat.text += " For <b> " + this.userConnected.nom + " " + this.userConnected.prenom + '</b>';
		}
		else {
			ebChat.text = fileType + " " + action + " by <b> " + this.userConnected.nom + " " + this.userConnected.prenom + '</b>';
		}
		this.chatService.addChat(Statique.controllerStatiqueListe + '/addChat', ebChat).subscribe((data) => {
			this.updateChatEmitter.emit(data);
		});
	}

	onUploadComplete(file: UploadFile) {
		let res = file.response.length > 0 ? file.response[0] : file.response;
		this.historizeChat(res.idCategorie, "uploaded");
	}

	retrieveListDocuments() {
		this.initFilesReturn();
		// faut envoyer l id de la demande
		// lors de laffichage
		this.pricingService
			.getListDocuments(this.module, this.ebDemande != null ? this.ebDemande.ebDemandeNum : null, this.ebExpedition != null ? this.ebExpedition.ebExpeditionNum : null, this.userConnected != null ? this.userConnected.ebUserNum : null)
			.subscribe(data => {
				this.filesReturn[FileType.INVOICE] = data[FileType.INVOICE];
				this.filesReturn[FileType.LISTE_COLISAGE] = data[FileType.LISTE_COLISAGE];
				this.filesReturn[FileType.DOUANE] = data[FileType.DOUANE];
				this.filesReturn[FileType.TRANSPORT_DOCUMENT] = data[FileType.TRANSPORT_DOCUMENT];
				this.filesReturn[FileType.OTHER] = data[FileType.OTHER];
				this.filesReturn[FileType.POD] = data[FileType.POD];
			});
	}

	deleteDocument(doc: FichierJoint, index: number, listDoc: Array<FichierJoint>) {
		this.modalService.confirm(
			this.ConstantsTranslate['CONFIRMATION'],
			this.ConstantsTranslate['DELETE_FILE_CONFIRMATION'],
			function () {
				this.pricingService.deleteDocument(doc.ebDemandeFichierJointNum).subscribe(function (it) {
					listDoc.splice(index, 1);
					this.historizeChat(doc.idCategorie, "deleted");
				}.bind(this));
			}.bind(this));
	}

	nextPage() {
		this.onValidate.emit();
	}

	fileMaxSizeError() {
		this.uploadEnCours = false;
		let title = null;
		let body = null;
		this.translate.get("MODAL.ERROR").subscribe((res: string) => { title = res; });
		this.translate.get("MODAL.SIZE_ALLOWED_1MB").subscribe((res: string) => { body = res; });
		this.modalService.information(title, body, function () { });
	}

	canUpload(fileType): boolean {

		if (this.uploadEnCours)
			return false;

		if (!this.hasContributionAccess)
			return false;

		if (this.module == Modules.PRICING) {
			if (fileType == this.fileTypeEnum.LISTE_COLISAGE || fileType == this.fileTypeEnum.INVOICE || fileType == this.fileTypeEnum.OTHER) {
				return true;
			}
		}
		else if (this.module == Modules.TRANSPORT_MANAGEMENT) {
			if (this.userConnected.role == UserRole.CHARGEUR) {
				return (fileType == this.fileTypeEnum.LISTE_COLISAGE || fileType == this.fileTypeEnum.INVOICE || fileType == this.fileTypeEnum.OTHER)
			}

			if (this.userConnected.service == ServiceType.TRANSPORTEUR) {
				return (fileType == this.fileTypeEnum.INVOICE || fileType == this.fileTypeEnum.TRANSPORT_DOCUMENT || fileType == this.fileTypeEnum.DOUANE || fileType == this.fileTypeEnum.OTHER);

			}

		}
		else if (this.module == Modules.TRACK) {
			if (this.userConnected.role == UserRole.CONTROL_TOWER)
				return true;
			if (this.userConnected.service == ServiceType.TRANSPORTEUR || this.userConnected.service == ServiceType.TRANSPORTEUR_BROKER) {
				if (this.userConnected.service == ServiceType.TRANSPORTEUR_BROKER) {
					return this.ebDemande.xEbTransporteurEtablissementNum == this.userConnected.ebEtablissement.ebEtablissementNum && (fileType == this.fileTypeEnum.POD);
				}
			}

		}
		return false;
	}

	// pour filtrer les types de documents à afficher selon le module (utilisé dans Track&Trace)
	canShow(fileType: number) {
		if (this.documentsToShow && this.documentsToShow.length > 0)
			return this.documentsToShow.find(it => it == fileType) ? true : false;
		return true;
	}
	canDeleteFile(f) {
		//User appartient à l'établissement ayant chargé le fichier
		if (this.userConnected.ebEtablissement.ebEtablissementNum == f.xEbEtablissemnt)
			return true;
		//user est controle tower
		if (this.userConnected.role == UserRole.CONTROL_TOWER)
			return true;
		//user est admin SETCARGO
		if (this.userConnected.role == UserRole.PRESTATAIRE && this.userConnected.admin == true)
			return true;
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/documents/documents.component.ts